import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CarOutlined, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import logo from "../../../Assets/Images/logo.svg";
import { getPublicQRScan } from "../../../API/Public/QRScan";
import "./style.css";

const getErrorMessage = (data, fallback) => {
  if (!data) return fallback;
  if (data.message) return data.message;
  if (data.detail) return data.detail;
  return fallback;
};

const QRScan = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [vehicle, setVehicle] = useState(null);

  useEffect(() => {
    if (!code) {
      setError("No QR code provided.");
      setLoading(false);
      return;
    }

    const fetchScan = async () => {
      try {
        const res = await getPublicQRScan(code);

        if (Math.floor(res?.status / 100) === 2) {
          setVehicle(res?.data?.data || null);
        } else {
          setError(getErrorMessage(res?.data, "Unable to load this QR code."));
        }
      } catch (err) {
        setError(
          getErrorMessage(err?.response?.data, "Unable to load this QR code."),
        );
      } finally {
        setLoading(false);
      }
    };

    fetchScan();
  }, [code]);

  return (
    <div className="qr-scan-page">
      <div className="qr-scan-page__card">
        <img src={logo} alt="FleeIQ" className="qr-scan-page__logo" />

        {loading && <div className="qr-scan-page__status">Loading...</div>}

        {!loading && error && (
          <div className="qr-scan-page__status qr-scan-page__status--error">
            {error}
          </div>
        )}

        {!loading && !error && vehicle && (
          <>
            <div className="qr-scan-page__vehicle-header">
              <div className="qr-scan-page__vehicle-icon">
                <CarOutlined />
              </div>
              <div>
                <div className="qr-scan-page__vehicle-name">
                  {vehicle.vehicle_name || "-"}
                </div>
                <div className="qr-scan-page__vehicle-plate">
                  {vehicle.license_plate || "-"}
                </div>
              </div>
            </div>

            <div className="qr-scan-page__details">
              <div className="qr-scan-page__row">
                <span className="qr-scan-page__label">Vehicle ID</span>
                <span className="qr-scan-page__value">
                  {vehicle.vehicle_id || "-"}
                </span>
              </div>
              <div className="qr-scan-page__row">
                <span className="qr-scan-page__label">Fleet Company</span>
                <span className="qr-scan-page__value">
                  {vehicle.fleet_company_name || "-"}
                </span>
              </div>
            </div>

            <div className="qr-scan-page__driver">
              <div className="qr-scan-page__driver-title">Driver</div>
              <div className="qr-scan-page__driver-row">
                <UserOutlined className="qr-scan-page__driver-icon" />
                <span>{vehicle.driver_name || "-"}</span>
              </div>
              {vehicle.driver_phone_number && (
                <a
                  className="qr-scan-page__driver-row qr-scan-page__driver-phone"
                  href={`tel:${vehicle.driver_phone_number}`}
                >
                  <PhoneOutlined className="qr-scan-page__driver-icon" />
                  <span>{vehicle.driver_phone_number}</span>
                </a>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default QRScan;
